import { Component, EventEmitter, Input, Output } from '@angular/core'
import { Observable } from 'rxjs'
import { Permissions } from 'src/app/core/enums/permissions.enum'
import { ProviderInfo } from 'src/app/obstacle/model/provider-info.model'

@Component({
  selector: 'app-bwc-layer-config',
  templateUrl: './bwc-layer-config.component.html',
  styleUrls: ['./bwc-layer-config.component.scss'],
  standalone: false,
})
export class BwcLayerConfigComponent {
  @Output() closed = new EventEmitter<void>()
  @Input() isLayerSelectionVisible: boolean = false
  @Input() providerInfo$!: Observable<ProviderInfo>

  Permissions = Permissions

  constructor() {}

  toggleLayerSwitchVisibility() {
    this.isLayerSelectionVisible = !this.isLayerSelectionVisible
  }

  public close() {
    this.isLayerSelectionVisible = false
  }
}
